import { useMemo } from 'react'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import { institutionLogoMap } from '@/src/constants/logoConstants'
import { PlaidItem } from '@/reducers/finances/plaidItemReducer'
import { inOperator } from '@/utils/typeHelpers'
import { Icon, Image } from '@/ui'

interface InstitutionLogoProps {
  institution: PlaidItem
  className: string
}

export const InstitutionLogo = ({
  institution,
  className,
}: InstitutionLogoProps) => {
  const src = useMemo(() => {
    const { logo, institutionName } = institution

    if (logo) return `data:image/png;base64, ${logo}`

    if (inOperator(institutionName, institutionLogoMap)) {
      return institutionLogoMap[institutionName]
    }

    return undefined
  }, [institution]) as string | undefined

  if (src) {
    return (
      <Image src={src} alt={`${institution.institutionName} logo`} width={48} />
    )
  }

  return (
    <div className={className}>
      <Icon icon={regular('bank')} size="lg" color="white" />
    </div>
  )
}
